/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { RESALE_DELETED_BOX } from "../graphql/resaleBox.mutate";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IResaleBoxMethods extends IPluginMethodMap {
  resaleBox(args: any): Promise<any>;
}

export class ResaleBoxService implements IAgentPlugin {
  readonly methods: IResaleBoxMethods;

  constructor() {
    this.methods = {
      resaleBox: this.resaleBox.bind(this),
    };
  }

  async resaleBox(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const boxId = args?.filter?._id || args?.id || args?._id;
        const res = await client.mutate({
          mutation: RESALE_DELETED_BOX,
          variables: {
            filter: {
              _id: boxId,
            },
            data: {
              email: args?.data?.email ?? args?.email,
              firstName: args?.data?.firstName ?? args?.firstName ?? "",
              lastName: args?.data?.lastName ?? args?.lastName ?? "",
              reason: args?.data?.reason ?? args?.reason ?? "Resale of deleted box via admin dashboard",
            },
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          return {
            ...res?.data?.resaleDeletedCostume,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
